import React from "react";
import { Result, Button } from "antd";
import { HomeOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import Header from "../../components/Header";

const NotFound = ()=>{
  return (
    <div className="NotFound">
      <Header activePath={''} />
      <Result
        status="404"
        title="404"
        subTitle="抱歉，您访问的页面不存在。"
        extra={[
          <Button type="primary" key="home">
            <Link to="/">
              <HomeOutlined /> 返回首页
            </Link>
          </Button>
        ]}
      />
    </div>
  )
}

export default NotFound;
